import { Link } from "react-router-dom";
import AuthShell from "./AuthShell";
import AuthButtonLink from "./AuthButtonLink";
import a from "./auth.module.css";

export default function RegistrationByLinkSuccess({
  clubName,
  email,
  loginPath,
  backLabel = "Назад",
  registrationPending = true,
  reusedParent = false,
  reusedSolo = false,
  message = "",
}) {
  const normalizedEmail = String(email || "").trim().toLowerCase();
  const pending = Boolean(registrationPending);
  const reused = Boolean(reusedParent || reusedSolo);

  const cardTitle = pending
    ? "Заявка отправлена"
    : reusedParent
      ? "Ребёнок добавлен"
      : reusedSolo
        ? "Добавлены в группу"
        : "Регистрация выполнена";

  const hint = pending
    ? "Осталось дождаться подтверждения тренера — затем придёт письмо для входа."
    : reused
      ? "Войдите в личный кабинет тем же email, что указали в заявке."
      : "Проверьте почту — там ссылка, чтобы задать пароль и войти.";

  const lead = message
    ? message
    : pending
      ? `Заявка принята${clubName ? ` в клуб «${clubName}»` : ""}. Обычно проверка занимает от нескольких часов до одного рабочего дня.`
      : reusedParent
        ? `Готово${clubName ? `: клуб «${clubName}»` : ""}. Откройте кабинет — новый спортсмен уже в семье.`
        : reusedSolo
          ? `Вы уже были в клубе${clubName ? ` «${clubName}»` : ""} — добавили вас в группу по ссылке.`
          : `Регистрация в${clubName ? ` клубе «${clubName}»` : " клубе"} завершена.`;

  return (
    <AuthShell
      modern
      wide
      backTo={loginPath}
      backLabel={backLabel}
      showSwitcher={false}
      clubTag={clubName}
      cardTitle={cardTitle}
      hint={hint}
    >
      <div className={a.regLinkSuccess}>
        <div className={a.regLinkSuccessIcon} aria-hidden>
          ✓
        </div>

        <p className={a.regLinkSuccessLead}>{lead}</p>

        {pending ? (
          <ol className={a.regLinkSuccessSteps}>
            <li>
              <span className={a.regLinkSuccessStepNum}>1</span>
              <span>Тренер или администратор проверит заявку</span>
            </li>
            <li>
              <span className={a.regLinkSuccessStepNum}>2</span>
              <span>
                На email придёт ссылка — задайте пароль и активируйте доступ
              </span>
            </li>
            <li>
              <span className={a.regLinkSuccessStepNum}>3</span>
              <span>В личном кабинете — расписание, абонементы и новости клуба</span>
            </li>
          </ol>
        ) : (
          <ol className={a.regLinkSuccessSteps}>
            <li>
              <span className={a.regLinkSuccessStepNum}>1</span>
              <span>
                {reused
                  ? "Войдите в кабинет тем же email, что указали в заявке"
                  : "Откройте письмо и задайте пароль по ссылке"}
              </span>
            </li>
            <li>
              <span className={a.regLinkSuccessStepNum}>2</span>
              <span>Проверьте группу, расписание и чаты в личном кабинете</span>
            </li>
            <li>
              <span className={a.regLinkSuccessStepNum}>3</span>
              <span>
                {reused
                  ? "Если вход не получается — напишите в клуб"
                  : "Если письма нет — загляните в «Спам» или напишите в клуб"}
              </span>
            </li>
          </ol>
        )}

        {normalizedEmail ? (
          <div className={a.regLinkSuccessEmail}>
            <span className={a.regLinkSuccessEmailLabel}>
              {pending || !reused ? "Письмо с активацией" : "Ваш email для входа"}
            </span>
            <strong>{normalizedEmail}</strong>
          </div>
        ) : (
          <p className={a.regLinkSuccessWarn}>
            Если письмо не пришло в течение суток — свяжитесь с клубом и уточните
            статус заявки.
          </p>
        )}

        <div className={a.regLinkSuccessActions}>
          <AuthButtonLink to={loginPath}>Ко входу</AuthButtonLink>
          <p className={a.regLinkSuccessFoot}>
            Уже есть доступ?{" "}
            <Link to={loginPath} className={a.footerLinksModern}>
              Войти в кабинет
            </Link>
          </p>
        </div>
      </div>
    </AuthShell>
  );
}
